import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { CommonBaseURl } from '../../Commonprovider/CommonProvider';
import { setCutoffDB, setTopYear } from '../../Redux/Slices/CommonLocalRedux/CommonSliceStorage';
import { setCurrency } from '../../Redux/Slices/CommonLocalRedux/CommonSliceStorage';
import { setCurrencyName } from '../../Redux/Slices/CommonLocalRedux/CommonSliceStorage';
import { setRsInValuedata } from '../../Redux/Slices/CommonLocalRedux/CommonSliceStorage';
import { setRsIn } from '../../Redux/Slices/CommonLocalRedux/CommonSliceStorage'
import { setOrder } from '../../Redux/Slices/CommonLocalRedux/CommonSliceStorage';
import { setNoOfDigit } from '../../Redux/Slices/CommonLocalRedux/CommonSliceStorage';
import { setCurrencyconvert } from '../../Redux/Slices/CommonLocalRedux/CommonSliceStorage'
const Setting = ({ setShowsettingPopup }) => {
    const Token = useSelector(state => state.Authenticationapi.token)
    const [BaseURL] = useState(CommonBaseURl)
    const UserDetails = useSelector(state => state.LoginUserDetails.data)
    const dispatch = useDispatch()
    //  const Currencyvalue = useSelector(state => state.LocalValuesData.Currency);
    const RsIn = useSelector(state => state.LocalValuesData.RsIn)
    const topYear = useSelector(state => state.LocalValuesData.TopYear)
    const NoOfDigit = useSelector(state => state.LocalValuesData.NoOfDigit)
    const Currencyval = useSelector(state => state.LocalValuesData.Currencyvalue)
    const CurrencyNamestore = useSelector(state => state.LocalValuesData.CurrencyName)
    const RsInValueStore = useSelector(state => state.LocalValuesData.RsInValue)
    const setRsIndatastore = useSelector(state => state.LocalValuesData.RsIn)
    const Orderstore = useSelector(state => state.LocalValuesData.Order)
    const CutoffDB = useSelector(state => state.LocalValuesData.CutoffDB)
    const [CurrencyData, setCurrencyData] = useState([]);
    const [dbnamelist, setDbnamelist] = useState([]);

    const [Year, setYear] = useState((topYear && Number(topYear) <= 10 ? topYear : '10'))
    const [Currencyvalues, setCurrencyvalues] = useState(String(Currencyval).replace(/\s+/g, " ").trim() || 's17')


    const [CurrencyName, setCurrencyNameData] = useState(CurrencyNamestore || 'Rs');

    const [RsInValue, setRsInValue] = useState(RsInValueStore || 'Crores');
    const [RsIndata, setRsIndata] = useState(setRsIndatastore || 1);
    const [NoOfDigitdata, setNoOfDigitdata] = useState(NoOfDigit || 2)
    const [Orderdata, setOrderdata] = useState(Orderstore || 'asc')
    const [dbnamelist1, setdbnamelist1] = useState(CutoffDB || '1')



    const GetCurrencyValues = () => {
        if (Token != null) {
            fetch(`${BaseURL}GetCurrencyValues?code=${Currencyvalues}`, {
                method: "GET",
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    Authorization: "Bearer " + Token.access_token,
                },
            })
                .then((response) => response.json())
                .then((json) => {
                    let data = JSON.parse(json);
                    dispatch(setCurrencyconvert(data[0].CURR_RATE));
                    // localStorage.setItem('currency', data[0].CURR_RATE)
                });
        }
    };
    const GetCurrencyMaster = () => {
        if (Token != null) {
            fetch(`${BaseURL}GetCurrencyMaster`,
                {
                    method: "GET",
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        'Authorization': 'Bearer ' + Token.access_token,
                    },
                })
                .then((response) => response.json())
                .then((json) => {
                    let data = JSON.parse(json);
                    setCurrencyData(data);
                });
        };
    };

    const CutOffDatabase = () => {
        if (Token != null) {
            fetch(`${BaseURL}GetCutOffDBList`,
                {
                    method: "GET",
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        'Authorization': 'Bearer ' + Token.access_token,
                    },
                })
                .then((response) => response.json())
                .then((json) => {
                    let data = JSON.parse(json);
                    setDbnamelist(data);
                    setdbnamelist1(data[0]['DBID'])
                });
        };
    };


    const handleSelectChangeCurrency = (e) => {
        const selectedCode = e.target.value;
        setCurrencyvalues(e.target.value);
        const matched = CurrencyData?.find(currency => (currency.Code || currency.CODE)?.toLowerCase() === selectedCode?.toLowerCase());
        setCurrencyNameData(matched?.Name || matched?.NAME || 'Rs');
    };

    const handleSelectChange = (e) => {
        const value = e.target.value;
        setRsInValue(value);
        // Determine the selected option based on the value
        switch (value) {
            case "Billions":
                setRsIndata("0.01");
                break;
            case "Crores":
                setRsIndata("1");
                break;
            case "Millions":
                setRsIndata("10");
                break;
            case "Lakhs":
                setRsIndata("100");
                break;
            case "Thousands":
                setRsIndata("10000");
                break;
            case "Hundreds":
                setRsIndata("100000");
                break;
            default:
                setRsIndata("1"); // Handle any unexpected values
        }
    };


    const submitSettingForm = async () => {
        GetCurrencyValues()
        dispatch(setTopYear(Year))
        dispatch(setCurrency(Currencyvalues))
        dispatch(setCurrencyName(CurrencyName))
        dispatch(setRsInValuedata(RsInValue))
        dispatch(setRsIn(RsIndata))
        dispatch(setOrder(Orderdata))
        dispatch(setNoOfDigit(NoOfDigitdata))
        dispatch(setCutoffDB(dbnamelist1))

        let params
        if (dbnamelist1 !== undefined) {
            params = ({
                "test": "Abc",
                "noofyear": Year,
                "FinOrderBy": Orderdata,
                "CurrCode": Currencyvalues,
                "CurrUnit": RsInValue,
                "userid": UserDetails[0].UserId || JSON.parse(UserDetails)[0].UserId,
                "PageSize": 10,
                "NoOfDecimals": NoOfDigitdata,
                "DefDB": dbnamelist1,//NEW LINE added for cutoff
                "test2": "Abc"
            });
        } else {
            params = ({
                "test": "Abc",
                "noofyear": Year,
                "FinOrderBy": Orderdata,
                "CurrCode": Currencyvalues,
                "CurrUnit": RsInValue,
                "userid": UserDetails[0].UserName || JSON.parse(UserDetails)[0].UserName,
                "PageSize": 10,
                "NoOfDecimals": NoOfDigit,
                "test2": "Abc"
            });
        }

        fetch(`${BaseURL}insertUserMas`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + Token.access_token,
            },
            body: new URLSearchParams(params).toString()
        })
            .then((response) => response.json())
            .then((json) => {
                const data = JSON.parse(json);
                // Store in Redux
                if (data[0].StatusMsg == "Settings updated successfully") {
                    alert("Settings updated successfully");
                    // $window.location.replace(localStorage["ls.lastUrl"]);
                    // window.location.reload();
                }
                else {
                    alert(data[0].StatusMsg);
                    // window.location.reload()
                }

            })
            .catch((error) => {
                console.error('Error:', error);
            });

        // alert("Updated setting successfully");
            setShowsettingPopup(false)

    };

    useEffect(() => {
        GetCurrencyMaster()
        CutOffDatabase()
    }, [])


    // useEffect(() => {
    //     GetCurrencyValues()
    // }, [Currencyvalues])

    return (
        <>
            <div className='modal fade show'
                style={{ display: 'block' }}
                tabIndex="-1"
                role="dialog"
            // ref={modalRef}
            >
                <div className='common-div' onClick={() => setShowsettingPopup(false)}></div>
                <div className='modal-dialog modal-lg'>
                    <div className='modal-content'>
                        <div className='landing-box-head'>
                            <h5>Setting</h5>
                        </div>
                        <div className='modal-body common-scroller popup-form'>
                            <div className="form-grup-container flex popup-color">
                                <div className="form-grup name contact-drp">
                                    <label for="">No Of Year</label>
                                    <div className="select-container">
                                        <select onChange={(e) => setYear(e.target.value)} value={Year}>
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="form-grup name contact-drp">
                                    <label for="">Currency</label>
                                    <div className="select-container">
                                        <select onChange={handleSelectChangeCurrency} value={Currencyvalues}>
                                            {CurrencyData.map((item) => (
                                                <option key={item.Name} value={item.Code} >{item.Name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="form-grup name contact-drp">
                                    <label for="">Units</label>
                                    <div className="select-container">
                                        <select onChange={handleSelectChange} value={RsInValue}>
                                            <option value="Billions">Billions</option>
                                            <option value="Crores">Crores</option>
                                            <option value="Millions">Millions</option>
                                            <option value="Lakhs">Lakhs</option>
                                            <option value="Thousands">Thousands</option>
                                            <option value="Hundreds">Hundreds</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="form-grup-container flex popup-color">
                                <div className="form-grup name contact-drp">
                                    <label for="">No Of Decimals</label>
                                    <div className="select-container">
                                        <select onChange={(e) => setNoOfDigitdata(e.target.value)} value={NoOfDigitdata}>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="form-grup name contact-drp">
                                    <label for="">Order</label>
                                    <div className="select-container">
                                        <select onChange={(e) => setOrderdata(e.target.value)} value={Orderdata}>
                                            <option value="asc">Ascending </option>
                                            <option value="desc">Descending</option>
                                        </select>
                                    </div>
                                </div>
                                {/* <div className="form-grup name contact-drp">
                                    <label for="">Select Cut Off Database</label>
                                    <div className="select-container">
                                        <select onChange={(e) => setdbnamelist1(e.target.value)} value={dbnamelist1}>
                                            {dbnamelist.map((item) => (
                                                <option key={item.Name} value={item.DBID} >{item.DBAlias}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className='modal-footer'>
                            <button type='button' className="bttn-close" onClick={() => setShowsettingPopup(false)}>
                                Close
                            </button>
                            <button type='button' className="bttn" onClick={submitSettingForm}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Setting
